// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-input__inner:disabled{background:var(--bg-disabled);cursor:not-allowed}.input__error{color:var(--text-error)}.input__error .i-simple{width:17px;height:17px}", ""]);
// Exports
module.exports = exports;
